
import L from 'leaflet';

// Create device icons for the map
export const createDeviceIcon = (deviceType: string, status: string) => {
  // Determine icon color based on status
  let iconColor = '#6E6E6E'; // Default gray for unknown status
  
  switch (status) {
    case 'Healthy':
      iconColor = '#22C55E'; // Green
      break;
    case 'Warning':
      iconColor = '#F59E0B'; // Yellow
      break;
    case 'Critical':
      iconColor = '#EF4444'; // Red
      break;
    case 'Offline':
    case 'Inactive':
      iconColor = '#6E6E6E'; // Gray
      break;
  }
  
  // Determine marker type based on device type
  let iconSvg = '';
  
  switch(deviceType) {
    case 'smartMeter':
      // Smart meter icon (meter with gauge)
      iconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1" />
          <path d="M12 6v6l4 2" stroke="#FFFFFF" stroke-width="1.5" />
        </svg>
      `;
      break;
    case 'gateway':
      // Gateway icon (network device)
      iconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1" />
          <line x1="8" y1="12" x2="16" y2="12" stroke="#FFFFFF" stroke-width="1.5" />
          <line x1="12" y1="8" x2="12" y2="16" stroke="#FFFFFF" stroke-width="1.5" />
        </svg>
      `;
      break;
    case 'voltageRegulator':
      // Voltage regulator icon (lightning bolt)
      iconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1" />
          <path d="M13 2L7 12h8l-4 8" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      `;
      break;
    default:
      // Default device icon (square)
      iconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1" />
        </svg>
      `;
  }
  
  // Create an icon with the SVG string
  return L.divIcon({
    html: iconSvg,
    className: `custom-device-icon device-type-${deviceType}`,
    iconSize: [24, 24],
    iconAnchor: [12, 12]
  });
};

// Create consumer icons for the map
export const createConsumerIcon = (status: string) => {
  const iconColor = getConsumerStatusColor(status);
  
  // Create a simple circle SVG for consumer markers
  const iconSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1">
      <circle cx="12" cy="12" r="8" fill="${iconColor}" stroke="#FFFFFF" stroke-width="1" />
      <path d="M12 8v8" stroke="#FFFFFF" stroke-width="1.5" />
      <path d="M8 12h8" stroke="#FFFFFF" stroke-width="1.5" />
    </svg>
  `;
  
  return L.divIcon({
    html: iconSvg,
    className: 'custom-consumer-icon',
    iconSize: [16, 16],
    iconAnchor: [8, 8]
  });
};

// Get consumer status color
export const getConsumerStatusColor = (status: string) => {
  switch (status) {
    case 'active':
      return '#4ADE80'; // Green
    case 'inactive':
      return '#A3A3A3'; // Gray
    case 'defaulter':
      return '#F87171'; // Red
    default:
      return '#A3A3A3'; // Default gray
  }
};

// Initialize Leaflet icons
export const initializeLeafletIcons = () => {
  // Fix for missing icon issue in Leaflet
  delete (L.Icon.Default.prototype as any)._getIconUrl;
  
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  });
};
